import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { appendCellFormatter, appendHeaderFormatter } from '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import selectableFormatter from './selectableFormatter.js';
import 'react';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-basic/form/Checkbox';
import '@elliemae/ds-basic/form/Radio';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function selectionColumnCreator(_ref) {
  var grid = _ref.grid,
      selectAll = _ref.selectAll,
      selectionComponent = _ref.selectionComponent,
      onSelectRow = _ref.onSelectRow,
      onSelectAll = _ref.onSelectAll,
      multiple = _ref.multiple,
      multiSelectFilterLabel = _ref.multiSelectFilterLabel,
      multiSelectFilterOptions = _ref.multiSelectFilterOptions,
      multiSelectFilterLabels = _ref.multiSelectFilterLabels,
      multiSelectComponent = _ref.multiSelectComponent;
  var rowKey = grid.props.rowKey;
  return function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref2$visible = _ref2.visible,
        visible = _ref2$visible === void 0 ? true : _ref2$visible,
        _ref2$isDataColumn = _ref2.isDataColumn,
        isDataColumn = _ref2$isDataColumn === void 0 ? false : _ref2$isDataColumn,
        _ref2$width = _ref2.width,
        width = _ref2$width === void 0 ? 40 : _ref2$width,
        minWidth = _ref2.minWidth;
        _ref2.cellRenderer;
        _ref2.headerCellRenderer;
        _ref2.customRenderer;
        _ref2.header;
        var column = _objectWithoutProperties(_ref2, ["visible", "isDataColumn", "width", "minWidth", "cellRenderer", "headerCellRenderer", "customRenderer", "header"]);

    var selectionColumn = _objectSpread(_objectSpread({}, column), {}, {
      property: 'metaData.selected',
      filterLabel: multiSelectFilterLabel,
      filterOptions: multiSelectFilterOptions,
      filterLabels: multiSelectFilterLabels,
      visible: visible,
      width: width,
      minWidth: minWidth || width,
      isDataColumn: isDataColumn
    });

    selectionColumn = appendCellFormatter(selectableFormatter({
      isMultiSelect: multiple,
      renderer: selectionComponent || multiSelectComponent,
      onSelect: onSelectRow
    }, grid))(selectionColumn);

    if (multiple) {
      selectionColumn = appendHeaderFormatter(selectableFormatter({
        rowKey: rowKey,
        selectAll: selectAll,
        isMultiSelect: true,
        isHeader: true,
        className: 'multi-select-wrapper',
        renderer: selectionComponent || multiSelectComponent,
        onSelect: onSelectAll
      }, grid))(selectionColumn);
    }

    return selectionColumn;
  };
}

export { selectionColumnCreator };
//# sourceMappingURL=addSelectableColumn.js.map
